(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["scroller"] && !Shopify.designMode) return;
  try {
    (() => {
    document.querySelectorAll('[data-scroller]').forEach((scroller) => {
      if (scroller.dataset.ready === 'true') return;
      scroller.dataset.ready = 'true';
      const track = scroller.querySelector('[data-scroller-track]');
      if (!track) return;
      scroller.querySelectorAll('[data-scroll]').forEach((button) => {
        button.addEventListener('click', () => {
          const direction = Number(button.getAttribute('data-scroll'));
          const card = track.firstElementChild;
          if (!card) return;
          const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
          const step = card.getBoundingClientRect().width + gap;
          track.scrollBy({ left: step * direction, behavior: 'smooth' });
        });
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
